import * as React from 'react';
import { useSelector } from 'react-redux';
import { debounce } from 'throttle-debounce';

import { selectAnalyticsUser } from '../../../selectors/analytics';
import { selectUserPhone } from '../../../selectors/user';
import { trackPhoneFill } from '../../../utils/analytics';

const DEBOUNCE_DELAY = 300;

export function usePhoneFillAnalytics() {
  const isSentRef = React.useRef<boolean>(false);
  const analyticsUser = useSelector(selectAnalyticsUser);
  const userPhone = useSelector(selectUserPhone);

  const phoneChangeHandler = React.useCallback(
    (inputPhone: string) => {
      if (!isSentRef.current) {
        trackPhoneFill(userPhone, inputPhone, analyticsUser);
        isSentRef.current = true;
      }
    },
    [analyticsUser, userPhone],
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return React.useCallback(debounce(DEBOUNCE_DELAY, phoneChangeHandler), []);
}
